import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const Client = ()=>{
    const [client, setClient] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`client?page=${page}`);
            setClient(data.data);
            setLastPage(data.meta.last_page)

        }
        )();
    },[page]);
    const del = async (id) =>{
        if(window.confirm("Are you sure you want to delete this record?")){
            await axios.delete(`client/${id}`);
            setClient(client.filter((client) => client.id !== id));
        }
    }
    return (
        <Wrapper pageTitle={'Client'}>
            <InnerNav createLink={'/clientCreate'} listLink={'/client'} />
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">Name </th>
                                    <th className="px-4 py-3">Email </th>
                                    <th className="px-4 py-3">Contact Phone </th>
                                    <th className="px-4 py-3">Notification Email </th>
                                    <th className="px-4 py-3">Notification Msisdn </th>
                                    <th className="px-4 py-3">CreatedAt </th>
                                     
                                    <th className="px-4 py-3">UpdatedAt </th>
                                     <th className="px-4 py-3">Action</th>
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                    {client.map((client)=>{
                                         return(
                                             <tr key={client.id} className="text-gray-700 dark:text-gray-400">
                                                 <td className="px-4 py-5">{client.id}</td>
                                                 <td className="px-4 py-3 text-sm">{client.name}</td>
                                                 <td className="px-4 py-3 text-sm">{client.email}</td>
                                                 <td className="px-4 py-3 text-sm">{client.contact_phone}</td>
                                                
                                                 <td className="px-4 py-3 text-sm">{client.notification_email}</td>
                                                 <td className="px-4 py-3 text-sm">{client.notification_msisdn}</td>
                                                 <td className="px-4 py-3 text-sm">{client.created_at}</td>
                                                 <td className="px-4 py-3 text-sm">{client.updated_at}</td>
                                                 <td className="flex px-4 py-3 text-sm"><Link className="btn btn-sm btn-outline-secondary px-5" to={`/client/${client.id}/edit`}><AiFillEdit/> </Link><span className="btn btn-sm btn-outline-secondary" onClick={()=>del(client.id)}> <AiFillDelete className="text-rose-500 text-lg"/></span></td>
                                             </tr>
                                         );
                                     })
                                 }
                            </tbody>
                        </table>
                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default Client;